import { useSearch } from "@tanstack/react-router";
import { AppointmentBooking } from "~/features/appointments/pages/booking";

const LAST_STEP = 2;

export function BookingPage() {
    const { date: dateParam, slot: slotParam, step = "1" } = useSearch({ from: "/(dashboard)/dashboard/weight-loss/appointments/booking" });

    const successUrl = `${window.location.origin}/dashboard/weight-loss/appointments/confirmation`;
    const errorUrl = `${window.location.origin}/dashboard/weight-loss/appointments/error`;

    const pageStep = Number(step);
    const currentStep = isNaN(pageStep) ? 1 : Math.max(Math.min(LAST_STEP, pageStep), 1)

    return (
        <AppointmentBooking step={currentStep} selectedDate={dateParam} selectedSlot={slotParam} to="/dashboard/weight-loss/appointments/booking" successUrl={successUrl} errorUrl={errorUrl} />
    )
}
